import {Layer} from '../../../service/Layer'
import {Table} from '../../../service/Table'

const saveLayer = async (context, payload) => {
  return new Promise((resolve, reject) => {
    const backEnd = Layer.build({})
    backEnd.update(payload).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        context.commit('setFeatureLayer', payload)
        resolve(res)
      }
    }).catch(error => {
      console.log(error)
      reject(error)
    })
  })
}
const setBaseLayer = async (context, payload) => {
  context.state.baseLayer = payload
  if (payload !== null) {
    if (payload.cClass === 'userdraw') return false
    const layerId = payload.objectid
    const backEnd = Layer.build({})
    await backEnd.getPrimaryKey(layerId).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        context.state.basePk = res.data[0]
      }
    })
  }
}
const setTargetLayer = async (context, payload) => {
  context.state.targetLayer = payload
  if (payload !== null) {
    if (payload.cClass === 'userdraw') return false
    const layerId = payload.objectid
    const backEnd = Layer.build({})
    await backEnd.getPrimaryKey(layerId).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        context.state.targetPk = res.data[0]
      }
    })
  }
}

export default {
  saveLayer,
  setBaseLayer,
  setTargetLayer
}
